import React from "react";
import { Divider, H5 } from "@blueprintjs/core";
import { useFormikContext } from "formik";
import { NewScheduleState } from "types";
import { getReadableCronExpression } from "utils/utils";
import "./Confirm.scss";

export default function Confirm() {
    const { values } = useFormikContext<NewScheduleState>();
    const { company, user_inputs, scheduleName, startTime, startDate, timeZone, active, cron } = {
        ...values
    };

    const renderUserInputs = () => {
        return Object.keys(user_inputs).map((k, i) => {
            const { name, value, type, label } = user_inputs[k];

            // list collector and reference types keep a user friendly readable name in name and the rest of the variables keep it in value
            const display = type === "reference" || type === "listcollector" ? name : value;
            return (
                <div key={i} id={`${i}`} className="variable">
                    <div className="variable-name">{label}</div>
                    <div className="variable-value">{display}</div>
                </div>
            );
        });
    };

    return (
        <div className="main-grid">
            <div className="grid-item">
                <H5>Project Variables</H5>
                <Divider />

                <div className="variables">
                    <div className="variable">
                        <div className="variable-name">Company</div>
                        <div className="variable-value">{company.name}</div>
                    </div>
                    {renderUserInputs()}
                </div>
            </div>
            <div className="grid-item">
                <H5>Schedule</H5>
                <Divider />
                <div className="variables">
                    <div className="variable">
                        <div className="variable-name">Schedule Name</div>
                        <div className="variable-value">{scheduleName}</div>
                    </div>
                    <div className="variable">
                        <div className="variable-name">Start Time</div>
                        <div className="variable-value">{startTime}</div>
                    </div>
                    <div className="variable">
                        <div className="variable-name">Time Zone</div>
                        <div className="variable-value">{timeZone.toString()}</div>
                    </div>
                    <div className="variable">
                        <div className="variable-name">Run Time</div>
                        <div className="variable-value">{getReadableCronExpression(cron, startTime, startDate)}</div>
                    </div>
                    <div className="variable">
                        <div className="variable-name">Active</div>
                        <div className="variable-value">{active ? "Yes" : "No"}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
